// extracted by mini-css-extract-plugin
export var contact = "Contacts-module--contact--832b2";
export var icon = "Contacts-module--icon--9bb31";
export var contactText = "Contacts-module--contactText--15ff4";